module.exports = __webpack_public_path__ + "media/images/placeholder__julia-mcdougall-ab8b05834628c29c5636e1f64ee69d5f.jpg";